import { render, staticRenderFns } from "./ProductCategoryEdit.vue?vue&type=template&id=18ab934e&scoped=true&"
import script from "./ProductCategoryEdit.vue?vue&type=script&lang=js&"
export * from "./ProductCategoryEdit.vue?vue&type=script&lang=js&"
import style0 from "./ProductCategoryEdit.vue?vue&type=style&index=0&id=18ab934e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ab934e",
  null
  
)

export default component.exports